import { Link, useLocation } from 'react-router-dom'
import { Users, LayoutDashboard, KanbanSquare } from 'lucide-react'

export default function Sidebar() {
  const location = useLocation()
  const links = [
    { to: '/dashboard', label: 'Clients',  icon: LayoutDashboard },
    { to: '/pipeline',  label: 'Pipeline', icon: KanbanSquare },
    { to: '/team',      label: 'Team',     icon: Users },
  ]
  return (
    <aside className="w-64 bg-slate-900 text-white p-6">
      <h2 className="text-xl font-bold mb-8 text-blue-400">⚡ Prorately</h2>
      <nav className="space-y-2">
        {links.map(({ to, label, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className={`flex items-center gap-3 p-2 rounded-lg transition ${
              location.pathname === to
                ? 'bg-blue-600 text-white'
                : 'hover:bg-slate-800 text-slate-300'
            }`}
          >
            <Icon size={18} />
            {label}
          </Link>
        ))}
      </nav>
    </aside>
  )
}